import {
  getPreviewImageNode,
  getPreviewLinkNodes,
} from "@joli-panini/gatsby-theme-joli-panini";

import type { GetPreview, WidgetShape } from "../types";

export const getPreview: GetPreview<"PageContentWidgetCustomContent"> = (
  widget
) => {
  return {
    ...widget,
    content: {
      ast: widget.content,
    },
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    linkNodes: <WidgetShape<"PageContentWidgetCustomContent">["linkNodes"]>(
      getPreviewLinkNodes(widget.linkNodes)
    ),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    imageNode: <WidgetShape<"PageContentWidgetCustomContent">["imageNode"]>(
      getPreviewImageNode(widget.imageNode)
    ),
  };
};
